@if (appLinks) {
  <button matIconButton [matMenuTriggerFor]="appsMenu">
    <mat-icon svgIcon="layout-grid" />
  </button>

  <mat-menu #appsMenu="matMenu">
    <div class="px-4 py-2 pb-1 text-xs font-bold text-neutral-11 uppercase">Applications</div>
    <div class="grid w-[240px] grid-cols-2 gap-2 p-2 pt-0">
      @for (app of apps(); track app.id) {
        @if (app.id === currentApp()) {
          <div
            class="flex flex-col items-center justify-center gap-y-2 rounded-md p-4 bg-primary-a3 border border-primary-6 cursor-default select-none"
          >
            <mat-icon class="text-primary-11" [svgIcon]="app.icon" />
            <span class="text-xs font-semibold text-primary-11">{{ app.label }}</span>
          </div>
        } @else {
          <a
            [href]="app.url"
            class="group flex flex-col items-center justify-center gap-y-2 rounded-md p-4 transition-colors hover:bg-neutral-a3"
          >
            <mat-icon class="text-neutral-11 group-hover:text-primary-11" [svgIcon]="app.icon" />
            <span class="text-xs font-medium text-neutral-11 group-hover:text-neutral-12">{{
              app.label
            }}</span>
          </a>
        }
      }
    </div>
  </mat-menu>
}
